import { render, staticRenderFns } from "./FieldWrapper.vue?vue&type=template&id=36e6880e&scoped=true"
import script from "./FieldWrapper.vue?vue&type=script&lang=js"
export * from "./FieldWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6880e",
  null
  
)

export default component.exports